<template>
  <div>
    <div class="flex flex-col space-y-4 md:flex-row md:space-y-0 md:justify-between">
      <div v-if="showPerPage">
        <my-dropdown v-model="myPerPage" :options="perPageOptions"></my-dropdown>
      </div>
      <div class="flex" :class="{'md:hidden':!showSort}">
        <my-dropdown v-model="mySort" class="w-full" select-class="rounded-r-none focus:z-10" :options="sortColumns"></my-dropdown>
        <my-button class="btn-white -ml-px rounded-l-none focus:z-10" @click="orderChange">
          <sort-down-icon v-if="myOrder==='asc'" class="inline w-4 h-4"></sort-down-icon>
          <sort-up-icon v-else class="inline w-4 h-4"></sort-up-icon>
        </my-button>
      </div>
      <div v-if="showFilter">
        <my-dropdown v-model="myFilter" :options="filters"></my-dropdown>
      </div>
      <div v-if="showSearch" class="relative">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"/>
          </svg>
        </div>
        <input class="block form-input w-full pl-10 pr-3 py-2" @input="onSearch" v-model="mySearch"
               type="search" placeholder="Search...">
      </div>
    </div>
  </div>
</template>
<script>
    import debounce from "lodash/debounce";

    export default {
        name: "table-controls",
        props: {
            filter: {type: String},
            filters: {type: Array},
            perPage: {type: Number, default: 10},
            order: {type: String, default: 'asc'},
            showFilter: {type: Boolean, default: false},
            showPerPage: {type: Boolean, default: false},
            showSearch: {type: Boolean, default: false},
            showSort: {type: Boolean, default: false},
            sort: {type: String},
            sortColumns: {type: Array, required: true}
        },
        data() {
            return {
                myPerPage: this.perPage + '',
                mySearch: '',
                myOrder: this.order,
                mySort: this.sort,
                myFilter: this.filter,
                perPageOptions: [
                    {value: "10", label: "10 per page"},
                    {value: "20", label: "20 per page"},
                    {value: "50", label: "50 per page"},
                ]
            }
        },
        computed: {
            sortColumnClasses() {
                return this.showSort ? 'field-wrap' : 'field-wrap.hidden';
            },
        },
        watch: {
            perPage() {
                this.myPerPage = this.perPage + '';
            },
            order(value) {
                this.myOrder = value;
            },
            sort(value) {
                this.mySort = value;
            },
            myFilter() {
                this.$emit('filter', this.myFilter);
            },
            myPerPage(value) {
                this.$emit('per-page', this.myPerPage);
            },
            mySort(value) {
                this.$emit('sort', [this.mySort, this.myOrder]);
            }
        },
        methods: {
            onSearch: debounce(function () {
                this.$emit('search', this.mySearch);
            }, 300),
            orderChange() {
                this.myOrder = (this.myOrder === 'asc') ? 'desc' : 'asc';
                this.$emit('sort', [this.mySort, this.myOrder]);
            }
        }
    }
</script>
